import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footers/Footer';
import IndexNavbar from 'components/Navbars/IndexNavbar';

const MentionsLegales = () => {
  // Styles réutilisables
  const sectionStyle = {
    marginBottom: '2.5rem',
    background: 'rgba(15, 23, 42, 0.5)',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid rgba(255, 255, 255, 0.05)'
  };

  const sectionHeaderStyle = {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#ffffff',
    margin: 0,
    padding: '1.25rem 2rem',
    background: 'linear-gradient(90deg, rgba(14, 165, 233, 0.2) 0%, rgba(59, 130, 246, 0.2) 100%)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  };

  const sectionContentStyle = {
    padding: '1.5rem 2rem'
  };

  const paragraphStyle = {
    color: '#e2e8f0', 
    margin: '0 0 1rem 0',
    lineHeight: '1.7'
  };

  const listStyle = {
    paddingLeft: '1.5rem',
    margin: '0 0 1rem 0'
  };

  const listItemStyle = {
    marginBottom: '0.5rem',
    lineHeight: '1.7',
    color: '#e2e8f0'
  };

  const highlightStyle = {
    color: '#0ea5e9',
    fontWeight: 600
  };

  const linkStyle = {
    color: '#0ea5e9',
    textDecoration: 'none',
    cursor: 'pointer'
  };

  const numberBadge = (number) => (
    <span style={{
      backgroundColor: '#0ea5e9',
      color: 'white',
      borderRadius: '9999px',
      width: '2rem',
      height: '2rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.875rem',
      fontWeight: 600,
      flexShrink: 0
    }}>
      {number}
    </span>
  );

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #0f172a 0%, #111827 35%, #0b1220 100%)',
      color: 'white',
      padding: '2rem 0',
      paddingTop: '6rem'
    }}>
      <main style={{
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1rem'
      }}>
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '3rem',
          padding: '2rem',
          background: 'rgba(255, 255, 255, 0.03)',
          borderRadius: '16px',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 800,
            color: '#ffffff',
            marginBottom: '1rem',
            background: 'linear-gradient(90deg, #0ea5e9, #3b82f6)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            Mentions Légales
          </h1>
          <p style={{
            fontSize: '1.125rem',
            color: '#94a3b8',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            Dernière mise à jour : 03 novembre 2025
          </p>
        </div>

        <div style={{
          backgroundColor: 'rgba(15, 23, 42, 0.7)',
          borderRadius: '16px',
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 10px -6px rgba(0, 0, 0, 0.2)',
          overflow: 'hidden',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{ 
            padding: '2.5rem',
            background: 'linear-gradient(180deg, rgba(30, 41, 59, 0.5) 0%, rgba(15, 23, 42, 0.7) 100%)'
          }}>
            {/* Article 1 : Éditeur du site */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(1)}
                Éditeur du site
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Le site <span style={highlightStyle}>AidFoundation</span> est édité par :
                </p>
                <div style={{
                  padding: '1.5rem',
                  background: 'rgba(14, 165, 233, 0.1)',
                  borderRadius: '8px',
                  border: '1px solid rgba(14, 165, 233, 0.2)',
                  marginBottom: '1rem'
                }}>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0', fontWeight: 600}}>AidFoundation</p>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0'}}>
                    Email : <a href="mailto:contact@aidfoundation.eu" style={linkStyle}>contact@aidfoundation.eu</a>
                  </p>
                </div>
              </div>
            </section>

            {/* Article 2 : Propriété intellectuelle */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(2)}
                Propriété intellectuelle
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  L'ensemble des éléments constituant le site (textes, images, vidéos, logos, etc.) sont la propriété exclusive de AidFoundation ou de ses partenaires. Toute reproduction, représentation, utilisation ou adaptation, sous quelque forme que ce soit, de tout ou partie des éléments du site sans accord préalable écrit est strictement interdite et constituerait un acte de contrefaçon.
                </p>
              </div>
            </section>

            {/* Article 3 : Protection des données personnelles */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(3)}
                Protection des données personnelles
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, de portabilité et d'opposition aux données vous concernant.
                </p>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Pour exercer ces droits, vous pouvez nous contacter à l'adresse suivante : <a href="mailto:contact@aidfoundation.eu" style={linkStyle}>contact@aidfoundation.eu</a>
                </p>
              </div>
            </section>

            {/* Article 4 : Cookies */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(4)}
                Cookies
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Notre site utilise des cookies pour améliorer votre expérience utilisateur. Pour en savoir plus sur l'utilisation des cookies et comment les gérer, veuillez consulter notre <Link to="/cookies" style={linkStyle}>Politique relative aux cookies</Link>.
                </p>
              </div>
            </section>

            {/* Article 5 : Droit applicable */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(5)}
                Droit applicable et juridiction compétente
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.
                </p>
              </div>
            </section>

            {/* Article 6 : Contact */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(6)}
                Contact
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Pour toute question ou réclamation concernant le site ou son contenu, vous pouvez nous contacter :
                </p>
                <div style={{
                  padding: '1.5rem',
                  background: 'rgba(14, 165, 233, 0.1)',
                  borderRadius: '8px',
                  border: '1px solid rgba(14, 165, 233, 0.2)'
                }}>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0'}}>
                    Email : <a href="mailto:contact@aidfoundation.eu" style={linkStyle}>contact@aidfoundation.eu</a>
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MentionsLegales;
